import type { UseModule } from '~/types'
import { install as StoreToolsFinancing } from '@solfacil/store-tools-financing'
import '@solfacil/store-tools-financing/dist/style.css'

export const install: UseModule = ({ instance }) => {
  instance.use(StoreToolsFinancing as any)
}
